import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AlertType } from 'src/app/Models/alert/alert-type';
import { Numero } from 'src/app/Models/numero/numero';
import { Usuario } from 'src/app/Models/usuario/usuario';
import { AuthService } from 'src/app/Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { NotifyService } from 'src/app/Service/notify.service';
import { InfoComponent } from '../../objects/info/info/info.component';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { AlertComponent } from '../../objects/alert/alert/alert.component';

@Component({
  selector: 'app-detalle-carga-liq',
  templateUrl: './detalle-carga-liq.component.html',
  styleUrls: ['./detalle-carga-liq.component.css']
})
export class DetalleCargaLiqComponent implements OnInit {

  @ViewChild('btnclose', null) btnclose: ElementRef;
  @ViewChild(AlertComponent, null) alert: AlertComponent;
  @ViewChild(LoadingComponent, null) loading: LoadingComponent;
  @ViewChild(InfoComponent, null) info: InfoComponent;
  @ViewChild('frmnewliquid', null) btnshownewliquid: ElementRef;
  public usuario: Usuario = new Usuario();
  public funcion: Function;
  public isShow: boolean = false;
  public serie_boleta: Numero = new Numero();
  public serie_factura: Numero = new Numero();
  public alertType: AlertType = new AlertType();
  public fechaHoraActual: Date;
  constructor(private title: Title, private data: DataService, private notify: NotifyService, private auth: AuthService, private route: Router) { }

  ngOnInit() {
  }


  public show(affterfunction: Function = null, fupdate: Function = null) {

    this.funcion = affterfunction;
    this.isShow = true;
    setTimeout(async () => {
      this.btnshownewliquid.nativeElement.click();
      this.loading.show('Cargando datos');
      this.loading.hide();
      console.log("mostrando series");
      console.log(this.serie_boleta);
      console.log(this.serie_factura);
    }, 10);
  }

  close() {
    this.btnclose.nativeElement.click();
    setTimeout(() => { this.isShow=false; }, 1000);
    setTimeout(() => {if (this.funcion != null) { this.funcion(); } }, 10);
  }


}
